<div class="mb-0 text-end mt-4 p-2 pb-0">
    <button *ngIf="canUploadRecoveryReporting" (click)="openUploadModal()" class="btn btn-primary me-2  radius-40"
    [ngClass]="{'btn-primary':opened}">Upload Recuvery Reporting
  </button>
  <button (click)="collapseHandler(true)" class="btn btn-primary me-2  radius-40"
    [ngClass]="{'btn-primary':opened}">Expand All
  </button>
  <button (click)="collapseHandler(false)" class="btn btn-primary radius-40" [ngClass]="{'btn-primary':opened}">Collapse
    All
  </button>
  <button *ngIf="admin_id == 1 || admin_id == 3 || admin_id == 71 || admin_id == 18 || admin_id == 75 || admin_id == 81" class="ms-2 btn btn-primary radius-40" data-bs-toggle="modal"
    data-bs-target="#dateModal">
    Get Weekly Data
  </button>

  <!-- Accounts across every product in one file — the debt recovery list exports
       one product at a time, this does not filter by product at all. -->
  <div class="btn-group ms-2" dropdown *ngIf="canExportAllProducts">
    <button id="all-product-export" dropdownToggle type="button"
      class="btn btn-primary radius-40 dropdown-toggle" aria-controls="all-product-export-menu"
      [disabled]="allProductExporting">
      {{ allProductExporting ? 'Preparing…' : 'Download All Products' }} <span class="caret"></span>
    </button>
    <ul id="all-product-export-menu" *dropdownMenu class="dropdown-menu dropdown-menu-end text-start" role="menu"
      aria-labelledby="all-product-export">
      <li role="menuitem">
        <button class="dropdown-item" tappable (click)="exportAllProductAccounts()">Accounts XLSX</button>
      </li>
      <li class="dropdown-divider"></li>
      <li role="menuitem">
        <button class="dropdown-item" tappable (click)="exportAllProductTloData()">TLO Data XLSX</button>
      </li>
    </ul>
  </div>
</div>

<accordion class="p-2" [class.embed-readonly]="embedded">

  <accordion-group heading="Contracts" [isOpen]="opened" [panelClass]="'dashboard-cards card-primary'"
    *ngIf="!_shared.routerAuth.restricted_buttons.doctor_stats">
    <div class="row ">
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-1 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
          [queryParams]="{page: 1, type: 1}">
          <h2>{{dashboard.financed_contracts ? dashboard.financed_contracts : '0'}}</h2>
          <h6 class="m-0">Total Financed Contracts</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-2 p-2" [routerLink]="'/app/contracts/list'"
          [queryParams]="{action: 16, startDate:today_start_date, endDate:today_end_date}">
          <h2>{{dashboard.today_contract_financed_requests ? dashboard.today_contract_financed_requests : '0'}}</h2>
          <h6 class="m-0">Financed Contracts Today</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-2 p-2" [routerLink]="'/app/contracts/list'"
          [queryParams]="{page: 1, type: 3, startDate:today_start_date, endDate:today_end_date}">
          <h2>{{dashboard.overdue_accounts ? dashboard.overdue_accounts : '0'}}</h2>
          <h6 class="m-0">Total Overdue Contracts</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-2 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
          [queryParams]="{page: 1, type: 4, startDate:today_start_date, endDate:today_end_date}">
          <h2>{{dashboard.ar_v2_total_paid_off ? dashboard.ar_v2_total_paid_off : '0'}}</h2>
          <h6 class="m-0">Total Completed Contracts</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-2 p-2 highlighted-div" [routerLink]="'/app/paid-in-full/list'">
          <h2>{{dashboard.completed_accounts ? dashboard.completed_accounts : '0'}}</h2>
          <h6 class="m-0">Total Settled Accounts</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-2 p-2 errored-div" [routerLink]="'/app/contracts/list'"
          [queryParams]="{page: 1, type: 5, startDate:today_start_date, endDate:today_end_date}">
          <h2>{{dashboard.canceled_accounts ? dashboard.canceled_accounts : '0'}}</h2>
          <h6 class="m-0">Total Canceled Contracts</h6>
        </div>
      </div>

    </div>
  </accordion-group>

  <accordion-group heading="Denefits Accounts" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    *ngIf="!_shared.routerAuth.restricted_buttons.split_request_stats">
    <div class="row">
      <!-- <div class="box-width col-sm-6 col-12">
      <div class="card bg-3 p-2 normal-div">
        <h2>{{dashboard.ar_v2_total_debt_recovered}}</h2>
        <h6 class="m-0">Total Debt Recovered</h6>
      </div>
    </div>
    <div class="box-width col-sm-6 col-12">
      <div class="card bg-3 p-2 highlighted-div normal-div">
        <h2>{{dashboard.ar_v2_total_debt_recovered_today}}</h2>
        <h6 class="m-0"> Total Debt Recovered Today</h6>
      </div>
    </div> -->
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-7 p-2" [routerLink]="'/app/debt-recovery/denefits'">
          <h2>{{dashboard.denefits_total_proposals}}</h2>
          <h6 class="m-0">Total Accounts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-8 p-2 highlighted-div" [routerLink]="'/app/debt-recovery/denefits'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date}">
          <h2>{{dashboard.denefits_total_proposals_today}}</h2>
          <h6 class="m-0">Total Accounts Added Today</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2">
          <h2>{{dashboard.denefits_total_contracts}}</h2>
          <h6 class="m-0">Financed Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 1}">
          <h2>{{dashboard.denefits_total_paid_off}}</h2>
          <h6 class="m-0">Total Accounts Paid off</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/paid-in-full/list'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date, qr_from: 1}">
          <h2>{{dashboard.denefits_total_paid_off_today}}</h2>
          <h6 class="m-0">Total Accounts Paid off Today</h6>
        </div>
      </div>
      <!-- <div class="box-width col-sm-6 col-12">
      <div class="card bg-3 p-2" [routerLink]="'/app/contracts/list'"
        [queryParams]="{type:0, sort:1, page:1, extraFilter:29}">
        <h2>{{dashboard.denefits_total_contracts}}</h2>
        <h6 class="mb-0">Total Debt Recovery Contracts </h6>
      </div>
    </div>
    <div class="box-width col-sm-6 col-12">
      <div class="card bg-5 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
        [queryParams]="{type:8,extraFilter:29, sD: today_start_date, eD: today_end_date}">
        <h2>{{dashboard.denefits_total_contracts_today}}</h2>
        <h6 class="m-0">Total Debt Recovery Contracts Today</h6>
      </div>
    </div> -->
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.denefits_delivered_emails}}</h2>
          <h6 class="m-0">Emails Reminders Sent</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.denefits_failed_emails}}</h2>
          <h6 class="m-0">Emails Reminders Failed</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.denefits_delivered_sms}}</h2>
          <h6 class="m-0">SMS Reminders Delivered</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.denefits_failed_sms}}</h2>
          <h6 class="m-0">SMS Reminders Failed</h6>
        </div>
      </div>
    </div>
  </accordion-group>

  <accordion-group heading="Recuvery Accounts" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    *ngIf="!_shared.routerAuth.restricted_buttons.split_request_stats">
    <div class="row">
      <!-- <div class="box-width col-sm-6 col-12">
      <div class="card bg-3 p-2 normal-div">
        <h2>{{dashboard.ar_v2_total_debt_recovered}}</h2>
        <h6 class="m-0">Total Debt Recovered</h6>
      </div>
    </div>
    <div class="box-width col-sm-6 col-12">
      <div class="card bg-3 p-2 highlighted-div normal-div">
        <h2>{{dashboard.ar_v2_total_debt_recovered_today}}</h2>
        <h6 class="m-0"> Total Debt Recovered Today</h6>
      </div>
    </div> -->
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-7 p-2" [routerLink]="'/app/debt-recovery/recuvery'">
          <h2>{{dashboard.recuvery_total_proposals}}</h2>
          <h6 class="m-0">Total Accounts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-8 p-2 highlighted-div" [routerLink]="'/app/debt-recovery/recuvery'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date}">
          <h2>{{dashboard.recuvery_total_proposals_today}}</h2>
          <h6 class="m-0">Total Accounts Added Today</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2">
          <h2>{{dashboard.recuvery_total_contracts}}</h2>
          <h6 class="m-0">Financed Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.recuvery_total_paid_off}}</h2>
          <h6 class="m-0">Total Accounts Paid off</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/paid-in-full/list'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date, qr_from: 0}">
          <h2>{{dashboard.recuvery_total_paid_off_today}}</h2>
          <h6 class="m-0">Total Accounts Paid off Today</h6>
        </div>
      </div>
      <!-- <div class="box-width col-sm-6 col-12">
      <div class="card bg-3 p-2" [routerLink]="'/app/contracts/list'"
        [queryParams]="{type:0, sort:1, page:1, extraFilter:29}">
        <h2>{{dashboard.recuvery_total_contracts}}</h2>
        <h6 class="mb-0">Total Debt Recovery Contracts </h6>
      </div>
    </div>
    <div class="box-width col-sm-6 col-12">
      <div class="card bg-5 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
        [queryParams]="{type:8,extraFilter:29, sD: today_start_date, eD: today_end_date}">
        <h2>{{dashboard.recuvery_total_contracts_today}}</h2>
        <h6 class="m-0">Total Debt Recovery Contracts Today</h6>
      </div>
    </div> -->
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.recuvery_delivered_emails}}</h2>
          <h6 class="m-0">Emails Reminders Sent</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.recuvery_failed_emails}}</h2>
          <h6 class="m-0">Emails Reminders Failed</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.recuvery_delivered_sms}}</h2>
          <h6 class="m-0">SMS Reminders Delivered</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.recuvery_failed_sms}}</h2>
          <h6 class="m-0">SMS Reminders Failed</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div normal-div" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.state_allowed}}</h2>
          <h6 class="m-0">States Allowed</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.state_not_allowed}}</h2>
          <h6 class="m-0">States Not Allowed</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div normal-div" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.recuvery_notice_sent}}</h2>
          <h6 class="m-0">Email Notice Sent</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.recuvery_notice_not_sent}}</h2>
          <h6 class="m-0">Email Notice Not Sent</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div normal-div" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.recuvery_ssn_provided}}</h2>
          <h6 class="m-0">SSN Provided</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 0}">
          <h2>{{dashboard.recuvery_ssn_not_provided}}</h2>
          <h6 class="m-0">SSN Not Provided</h6>
        </div>
      </div>
    </div>
  </accordion-group>
  <accordion-group heading="Lendee Accounts" [isOpen]="opened" [panelClass]="'dashboard-cards'"
  *ngIf="!_shared.routerAuth.restricted_buttons.split_request_stats">
    <div class="row">
  
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-7 p-2" [routerLink]="'/app/debt-recovery/lendee'">
          <h2>{{dashboard.lendee_total_proposals}}</h2>
          <h6 class="m-0">Total Accounts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-8 p-2 highlighted-div" [routerLink]="'/app/debt-recovery/lendee'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date}">
          <h2>{{dashboard.lendee_total_proposals_today}}</h2>
          <h6 class="m-0">Total Accounts Added Today</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2">
          <h2>{{dashboard.lendee_total_contracts}}</h2>
          <h6 class="m-0">Financed Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 2}">
          <h2>{{dashboard.lendee_total_paid_off}}</h2>
          <h6 class="m-0">Total Accounts Paid off</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/paid-in-full/list'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date, qr_from: 2}">
          <h2>{{dashboard.lendee_total_paid_off_today}}</h2>
          <h6 class="m-0">Total Accounts Paid off Today</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.lendee_delivered_emails}}</h2>
          <h6 class="m-0">Emails Reminders Sent</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.lendee_failed_emails}}</h2>
          <h6 class="m-0">Emails Reminders Failed</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.lendee_delivered_sms}}</h2>
          <h6 class="m-0">SMS Reminders Delivered</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.lendee_failed_sms}}</h2>
          <h6 class="m-0">SMS Reminders Failed</h6>
        </div>
      </div>
    </div>
  </accordion-group>

  <accordion-group heading="Credee Accounts" [isOpen]="opened" [panelClass]="'dashboard-cards'"
  *ngIf="!_shared.routerAuth.restricted_buttons.split_request_stats">
    <div class="row">
  
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-7 p-2" [routerLink]="'/app/debt-recovery/credee'">
          <h2>{{dashboard.credee_total_proposals}}</h2>
          <h6 class="m-0">Total Accounts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-8 p-2 highlighted-div" [routerLink]="'/app/debt-recovery/credee'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date}">
          <h2>{{dashboard.credee_total_proposals_today}}</h2>
          <h6 class="m-0">Total Accounts Added Today</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2">
          <h2>{{dashboard.credee_total_contracts}}</h2>
          <h6 class="m-0">Financed Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2" [routerLink]="'/app/paid-in-full/list'" [queryParams]="{qr_from: 3}">
          <h2>{{dashboard.credee_total_paid_off}}</h2>
          <h6 class="m-0">Total Accounts Paid off</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/paid-in-full/list'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date, qr_from: 3}">
          <h2>{{dashboard.credee_total_paid_off_today}}</h2>
          <h6 class="m-0">Total Accounts Paid off Today</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.credee_delivered_emails}}</h2>
          <h6 class="m-0">Emails Reminders Sent</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.credee_failed_emails}}</h2>
          <h6 class="m-0">Emails Reminders Failed</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard.credee_delivered_sms}}</h2>
          <h6 class="m-0">SMS Reminders Delivered</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h2>{{dashboard.credee_failed_sms}}</h2>
          <h6 class="m-0">SMS Reminders Failed</h6>
        </div>
      </div>
    </div>
  </accordion-group>

  <accordion-group heading="Businesses" [isOpen]="opened" [panelClass]="'dashboard-cards card-primary'"
    *ngIf="!_shared.routerAuth.restricted_buttons.doctor_stats">
    <div class="row ">
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-1 p-2" [routerLink]="'/app/business/list'"
          [queryParams]="{status: 1, country_id: country_id}">
          <h2>{{dashboard.active_doctors ? dashboard.active_doctors : '0'}}</h2>
          <h6 class="m-0">Total Businesses</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-2 p-2" [routerLink]="'/app/business/list'"
          [queryParams]="{action: 16, startDate:today_start_date, endDate:today_end_date}">
          <h2>{{dashboard.active_doctors_today ? dashboard.active_doctors_today : '0'}}</h2>
          <h6 class="m-0">Businesses Registered Today</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 errored-div" [routerLink]="'/app/business/list'"
          [queryParams]="{action:5, status:1, type:21}">
          <h2>{{dashboard.total_disabled_accounts ? dashboard.total_disabled_accounts : '0'}}</h2>
          <h6 class="m-0">Transfers Disabled Accounts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-5 p-2 highlighted-div" [routerLink]="'/app/business/list'" [queryParams]="{type: 15}">
          <h2>{{dashboard.active_doctors_this_month ? dashboard.active_doctors_this_month : '0'}}</h2>
          <h6 class="m-0">Active Businesses This Month</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'" [queryParams]="{type: 14}">
          <h2>{{dashboard.active_doctors_this_month_30 ? dashboard.active_doctors_this_month_30 : '0'}}</h2>
          <h6 class="m-0">Active Businesses In Last 30 Days</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'"
          [queryParams]="{type: 4, status:1}">
          <h2>{{dashboard.total_business_without_bank ? dashboard.total_business_without_bank : '0'}}</h2>
          <h6 class="m-0">Businesses Without Bank Account</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'"
          [queryParams]="{type: 23, status:1}">
          <h2>{{dashboard.total_business_without_training ? dashboard.total_business_without_training : '0'}}</h2>
          <h6 class="m-0">Businesses With No Training</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'"
          [queryParams]="{type: 13, status:1}">
          <h2>{{dashboard.total_business_without_approved ? dashboard.total_business_without_approved : '0'}}</h2>
          <h6 class="m-0">Businesses Not Approved</h6>
        </div>
      </div>
    </div>
  </accordion-group>

  <accordion-group heading="Customers" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    *ngIf="!_shared.routerAuth.restricted_buttons.patient_stats">
    <div class="row ">
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2" [routerLink]="'/app/customers'" [queryParams]="{filter:1, type:1, status:2}">
          <h2>{{dashboard.active_patients ? dashboard.active_patients : '0'}}</h2>
          <h6 class="m-0">Customers with Contract</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-7 p-2" [routerLink]="'/app/customers'" [queryParams]="{filter:2, type:2, status:2}">
          <h2>{{dashboard.patients_without_contracts ? dashboard.patients_without_contracts : '0'}}</h2>
          <h6 class="m-0">Customers without Contract</h6>
        </div>
      </div>

      <div class="box-width col-sm-6 col-12">
        <div class="card bg-8 p-2" [routerLink]="'/app/customers'"
          [queryParams]="{action: 16, startDate:today_start_date, endDate:today_end_date}">
          <h2>{{dashboard.new_patients_today ? dashboard.new_patients_today : '0'}}</h2>
          <h6 class="m-0">Customers Registered Today</h6>
        </div>
      </div>

      <!-- <div class="box-width col-sm-6 col-12">
        <div class="card bg-8 p-2">
          <h2>{{dashboard.self_verified_customers ? dashboard.self_verified_customers : '0'}}</h2>
          <h6 class="m-0">Self Verified Customers</h6>
        </div>
      </div> -->
    </div>
  </accordion-group>

  <accordion-group heading="Demand Letters" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    *ngIf="dashboard['demand_letter_stats_data']">
    <div class="row">
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 normal-div">
          <h2>{{dashboard && dashboard.demand_letter_stats_data && dashboard.demand_letter_stats_data.total}}</h2>
          <h6 class="m-0">Letters Dispatched</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 highlighted-div normal-div">
          <h2>{{dashboard && dashboard.demand_letter_stats_data && dashboard.demand_letter_stats_data.scanned}}</h2>
          <h6 class="m-0">QR code Scanned</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-3 p-2 normal-div">
          <h2>{{dashboard && dashboard.demand_letter_stats_data && dashboard.demand_letter_stats_data.not_scanned}}</h2>
          <h6 class="m-0">QR code not Scanned</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h6 class="m-0">{{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.active_contracts}} Active Contracts</h6>
          <h6 class="m-0">Amount Processed: {{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.active_total_amt.toFixed(2)}}</h6>
          <h6 class="m-0">Paid to business: {{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.active_total_pod.toFixed(2)}}</h6>
          <h6 class="m-0">Paid to partner: {{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.active_total_pop.toFixed(2)}}</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 normal-div">
          <h2>{{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.overdue_contracts}}</h2>
          <h6 class="m-0">Overdue Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h6 class="m-0">{{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.completed_contracts}} Completed Contracts</h6>
          <h6 class="m-0">Amount Processed: {{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.complete_total_amt.toFixed(2)}}</h6>
          <h6 class="m-0">Paid to business: {{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.complete_total_pod.toFixed(2)}}</h6>
          <h6 class="m-0">Paid to partner: {{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.complete_total_pop.toFixed(2)}}</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 normal-div">
          <h2>{{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.cancelled_contracts}}</h2>
          <h6 class="m-0">Cancelled Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h2>{{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.total_settlement_contracts}}</h2>
          <h6 class="m-0">Total Settlement Contracts</h6>
        </div>
      </div>
      <div class="box-width col-sm-6 col-12">
        <div class="card bg-6 p-2 normal-div">
          <h2>{{currencySymbol}}{{dashboard && dashboard.demand_letter_stats_data &&
            dashboard.demand_letter_stats_data.settlement_financed_amount.toFixed(2)}}</h2>
          <h6 class="m-0">Settlement Financed Amount</h6>
        </div>
      </div>
    </div>
  </accordion-group>
</accordion>

<div class="modal fade" id="dateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Select Date</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="row" [formGroup]="dateForm">
          <div class="position-relative">
            <label class="fs-14 fw-400 m-0">Start Date</label>
            <input type="text" bsDatepicker #start_date="bsDatepicker" class="input_field" readonly (keydown)="false"
              formControlName="start_date" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY'}" />
            <span class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center pointer"
              style="position: absolute; top: 12px; right: 0;" (click)="start_date.show()">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
  
          <div class="position-relative">
            <label class="fs-14 fw-400 m-0">End Date</label>
            <input type="text" bsDatepicker #end_date="bsDatepicker" class="input_field" readonly (keydown)="false"
              formControlName="end_date" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY'}" />
            <span class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center pointer"
              style="position: absolute; top: 12px; right: 0;" (click)="end_date.show()">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <button type="button" (click)="getWeeklyData()" class="btn btn-primary radius-40">
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 430px;">
    <div class="modal-content border-0" style="box-shadow: 0 4px 12px rgba(0,0,0,0.15); background: #f8f8f8;">
      <div class="modal-header border-0" style="background: #348d3d; padding: 15px 20px;">
        <h5 class="modal-title text-white fw-bold" id="uploadModalLabel" style="font-size: 18px;">Upload</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="padding: 25px 20px; background: #f8f8f8;">
        <form [formGroup]="uploadForm">
          <div class="mb-4">
            <button type="button" class="btn p-0 d-flex align-items-center gap-2" 
              (click)="triggerFileUpload()"
              style="background: #e8e8e8; color: #333; padding: 8px 12px !important; border-radius: 4px; border: none; text-decoration: none;">
              <i class="fa fa-plus" style="font-size: 16px;"></i> 
              <span style="font-size: 14px; font-weight: 500;">Upload</span>
            </button>
            <input type="file" 
              #fileInput 
              hidden 
              accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" 
              (change)="onFileSelected($event)" />
          </div>
          <div *ngIf="selectedFileName" class="mb-3" style="padding: 10px; background: #e8f5e9; border: 1px solid #c8e6c9; border-radius: 4px;">
            <div style="font-size: 13px; color: #2e7d32;">
              <i class="fa fa-check-circle me-2" style="color: #4caf50;"></i>
              <span>File selected: <strong>{{ selectedFileName }}</strong></span>
              <button type="button" class="btn btn-link p-0 ms-2" (click)="clearSelectedFile()" style="font-size: 12px; color: #d32f2f;">
                Remove
              </button>
            </div>
          </div>
          <div class="mb-0">
            <label for="notesInput" class="form-label" style="font-size: 14px; font-weight: 600; color: #333; margin-bottom: 8px;">Notes<span class="text-danger">*</span></label>
            <textarea class="form-control" id="notesInput" formControlName="notes" rows="5" 
              placeholder="Enter notes here" 
              style="resize: none; border: 1px solid #ddd; background: white; font-size: 14px; color: #666; padding: 12px;"></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer border-0 d-grid gap-2" style="padding: 20px; background: #f8f8f8;">
        <button type="button" class="btn fw-bold text-white" (click)="submitUpload()" 
          style="background: #348d3d; padding: 12px 20px; font-size: 16px; border: none; border-radius: 4px;">
          Add
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="uploadResultModal" tabindex="-1" aria-labelledby="uploadResultModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 520px;">
    <div class="modal-content border-0" style="box-shadow: 0 4px 12px rgba(0,0,0,0.15); background: #f8f8f8;">
      <div class="modal-header border-0" style="background: #348d3d; padding: 15px 20px;">
        <div>
          <h5 class="modal-title text-white fw-bold mb-1" id="uploadResultModalLabel" style="font-size: 18px;">Upload Result</h5>
          <div class="text-white-50" style="font-size: 13px;">Uploaded {{ uploadedAccountCount }} Account ID</div>
        </div>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closeUploadResultModal()"></button>
      </div>
      <div class="modal-body" style="padding: 20px; background: #f8f8f8;">
        <div class="mb-3 p-3" style="background: #fff7e6; border: 1px solid #f4d08a; border-radius: 6px; color: #8a5a00; font-size: 14px;">
          {{ uploadResultMessage }}
        </div>
        <div *ngIf="notFoundAccounts.length; else noMissingAccounts">
          <div class="mb-2 d-flex align-items-center justify-content-between">
            <span class="fw-600" style="font-size: 14px; color: #333; text-transform: uppercase;">Not found Accounts ID</span>
            <a href="javascript:void(0)" (click)="exportNotFoundAccounts()"
              style="font-size: 14px; color: #d9534f; text-decoration: underline; font-weight: 600; text-transform: uppercase;">
              <b>Export</b>
            </a>
          </div>
          <div style="max-height: 280px; overflow-y: auto; border: 1px solid #d7d7d7; border-radius: 6px; background: #fff;">
            <div *ngFor="let account of notFoundAccounts; let index = index" class="d-flex align-items-center justify-content-between px-3 py-2" [ngStyle]="{ 'background': index % 2 === 0 ? '#fafafa' : '#ffffff', 'border-bottom': index < notFoundAccounts.length - 1 ? '1px solid #eee' : 'none' }">
              <span style="font-size: 14px; color: #333; text-transform: uppercase;">{{ account }}</span>
              <span class="badge bg-danger" style="text-transform: uppercase;">Not Found</span>
            </div>
          </div>
        </div>
        <ng-template #noMissingAccounts>
          <div class="text-center py-3" style="font-size: 14px; color: #2e7d32;">
            All uploaded accounts were updated successfully.
          </div>
        </ng-template>
      </div>
      <div class="modal-footer border-0 d-grid gap-2" style="padding: 20px; background: #f8f8f8;">
        <button type="button" class="btn fw-bold text-white" (click)="closeUploadResultModal()"
          style="background: #348d3d; padding: 12px 20px; font-size: 16px; border: none; border-radius: 4px;">
          Close
        </button>
      </div>
    </div>
  </div>
</div>